import { Box, Button, Paper, Typography } from "@mui/material";

export function NotFoundPage({ onHome }: { onHome: () => void }) {
  return (
    <Box className="min-h-[calc(100vh-117px)] bg-stone-100 p-4 sm:p-8">
      <Paper variant="outlined" elevation={0} className="mx-auto max-w-2xl p-7 text-center sm:p-10">
        <Typography color="primary" variant="overline" sx={{ fontWeight: 950 }}>404 · Route not found</Typography>
        <Typography component="h1" variant="h3" sx={{ fontWeight: 950, mt: 1 }}>This workspace does not exist.</Typography>
        <Typography sx={{ color: "text.secondary", mt: 2 }}>
          Use the AppShell navigation or return to the Media & Content Command Center.
        </Typography>
        <Button variant="contained" sx={{ mt: 3 }} onClick={onHome}>Open Command Center</Button>
      </Paper>
    </Box>
  );
}
